import React, { useState } from 'react';
import Button from '../../../Components/ui/button/Button';

const DownloadPopup = ({ setShowDownloadModal }) => {
  const [formData, setFormData] = useState({ firstName: '', email: '' });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  return (
    <div className="flex flex-col gap-4 rounded-[16px] p-10">
      <h1 className="fredokaOne text-center text-[40px] font-medium leading-normal tracking-[-0.8px] text-[#012E33]">
        Download the Guide
      </h1>
      <form
        className="space-y-[15px]"
        onSubmit={(e) => {
          e.preventDefault();
          setShowDownloadModal(false);
        }}
      >
        <div>
          <input
            type="text"
            id="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
            className="w-full rounded-[8px] border border-[#DCDCDC] bg-[#F5F5F5] p-2 outline-none md:p-3"
          />
        </div>
        <div>
          <input
            type="email"
            id="email"
            placeholder="Enter Email"
            value={formData.email}
            onChange={handleChange}
            className="w-full rounded-[8px] border border-[#DCDCDC] bg-[#F5F5F5] p-2 outline-none md:p-3"
          />
        </div>
        <Button
          label={'Download the guide'}
          className="!h-12 w-full !p-1 md:px-6 md:py-2 "
          type="submit"
        />
      </form>
    </div>
  );
};

export default DownloadPopup;
